import { observer } from "mobx-react-lite";

import { usePlayground } from "../Playground/playground-store";

import { useSchemaEditor } from ".";

import JinjaIcon from "@/assets/JinjaIcon";
import HelpTooltip from "@/components/ui/HelpTooltip";

const JinjaHelpTooltip = ({ onConfirmFormat }: { onConfirmFormat: () => void }) => {
  const { isUsingJinja } = useSchemaEditor();
  try {
    usePlayground();
    return (
      <HelpTooltip
        content={
          isUsingJinja
            ? "Use {{variable}} to dynamically inject values"
            : "Click here to update template format to `jinja2`"
        }
        onClick={!isUsingJinja ? onConfirmFormat : undefined}
        icon={<JinjaIcon empty={!isUsingJinja} />}
      />
    );
  } catch {
    return null; // Don't render if there is no valid playground context.
  }
};

export default observer(JinjaHelpTooltip);
